import React, { useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '@cpg-its/ads.containers.banner';
import { Toast } from '../../../../global/components/messages/toast';
import { ToastCombo } from '../../../../global/components/messages/toast-combo';
import { TcsmStates } from '../../../../root/tcsm-model';
import { PersonSearchProps } from '../../models/arc-epi-props';
import { PersonSearchContext, PersonSearchState } from './person-search-model';
import { setHideToast } from './person-search-slice';
import { PersonSearchToast } from './person-search-toast';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';

interface PersonSearchToastProps {
    renderResultsMessaging: boolean;
    searchResultsRef: React.MutableRefObject<any>;
}

export function PersonSearchToastCombo(props: PersonSearchToastProps) {
    const { renderResultsMessaging, searchResultsRef } = props;

    const personSearchKey = useContext(PersonSearchContext);
    const personSearchState = useSelector<TcsmStates, PersonSearchState>(state => state.personSearchState[personSearchKey]);
    const personSearchProps = useSelector<TcsmStates, PersonSearchProps>(state => state.epiProps.personSearchSettingsState.epiContent);
    const dispatch = useDispatch();
    const messageRef = useRef<any>();

    return (
        <ToastCombo
            renderEmbeddedMessage={renderResultsMessaging}
            toast={
                <Toast
                    message={<PersonSearchToast searchResultsRef={searchResultsRef} />}
                    hide={personSearchState.hideToast}
                    onClose={() => dispatch(setHideToast(true, personSearchKey))} />
            }
            embeddedMessage={
                <div ref={messageRef}>
                    <ContentSpacer>
                    <Banner
                        banner={{
                            type: 'warning',
                            label: <h5>{personSearchProps?.matchesFoundEmbeddedTitle}</h5>,
                            description: <p>{personSearchProps?.matchesFoundEmbeddedMessage}</p>,
                        }}
                        />
                        </ContentSpacer>
                </div>
            }
            messageRef={messageRef}
        />
    );
}